// This file was auto-generated by Fern from our API Definition.
export var PlaygroundBuildKitContext;
(function (PlaygroundBuildKitContext) {
    let OpAccess;
    (function (OpAccess) {
        OpAccess.Value = {
            Read: "read",
            Write: "write",
        };
    })(OpAccess = PlaygroundBuildKitContext.OpAccess || (PlaygroundBuildKitContext.OpAccess = {}));
})(PlaygroundBuildKitContext || (PlaygroundBuildKitContext = {}));
